import React from 'react';
import PropTypes from 'prop-types';
import { FormTextarea } from 'components/form';
import PhotoUpload from 'components/photo-upload';

const OtherVehicleFields = ({ vehicle, index, onChange }) => {
  const update = (partial) => onChange({ ...vehicle, ...partial });

  return (
    <div className="mt-4 pt-4 border-t border-dashed border-gray-300 first:mt-0 first:pt-0 first:border-t-0">
      <p className="text-xs font-bold uppercase tracking-wide text-green-regular mb-2">
        {`Other vehicle ${index}`}
      </p>

      <FormTextarea
        label="Vehicle contact info"
        value={vehicle?.contact || ''}
        placeholder="Name, phone, address, email"
        hint="Contact info for this vehicle's owner or operator."
        handleValue={(contact) => update({ contact })}
      />

      <div className="mt-3">
        <PhotoUpload
          label="Driver's License photo"
          hint="Photo of this party's Drivers License (or comment on failure)."
          files={vehicle?.driversLicensePhoto || []}
          onChange={(files) => update({ driversLicensePhoto: files })}
          allowComment
          commentValue={vehicle?.driversLicenseComment}
          onCommentChange={(driversLicenseComment) => update({ driversLicenseComment })}
        />
      </div>

      <div className="mt-3">
        <PhotoUpload
          label="License Plate photo"
          hint="Photo of this vehicle's license plate (or comment on failure)."
          files={vehicle?.licensePlatePhoto || []}
          onChange={(files) => update({ licensePlatePhoto: files })}
          allowComment
          commentValue={vehicle?.licensePlateComment}
          onCommentChange={(licensePlateComment) => update({ licensePlateComment })}
        />
      </div>

      <div className="mt-3">
        <PhotoUpload
          label="Insurance photo"
          hint="Photo of this party's Insurance Verification (or comment on failure)."
          files={vehicle?.insurancePhoto || []}
          onChange={(files) => update({ insurancePhoto: files })}
          allowComment
          commentValue={vehicle?.insuranceComment}
          onCommentChange={(insuranceComment) => update({ insuranceComment })}
        />
      </div>

      <div className="mt-3">
        <PhotoUpload
          label="Damage photos"
          hint="Photos of damage to this vehicle or property."
          max={4}
          files={vehicle?.damagePhotos || []}
          onChange={(files) => update({ damagePhotos: files })}
        />
      </div>
    </div>
  );
};

OtherVehicleFields.propTypes = {
  vehicle: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default OtherVehicleFields;
